<template>
    <div class="bg-surface-secondary w-100">
        <modal-detail v-if="ondetail" :ondetail="ondetail" :data="package" @onclose="CLEAR()" ></modal-detail>
        <modal-capture v-if="oncapture" :oncapture="oncapture" @onclose="oncapture = false" @save="SAVE"></modal-capture>
        <header class="bg-surface-primary border-bottom">
            <div class="container-fluid py-4">
                <div class="row align-items-center">
                    <div class="col">
                        <div class="d-flex align-items-center gap-4">
                            <div>
                                <button type="button" class="btn-close text-xs" @click="$router.replace({ name: 'PackageCreateMiami' }).catch(()=>{})"></button>
                            </div>
                            <div class="vr opacity-20 my-1"></div>
                            <h1 class="h4 ls-tight">Crear nuevo paquete en Miami</h1>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="hstack gap-2 justify-content-end">
                            <button class="btn btn-h btn-danger px-3" @click="$router.replace({ name: 'PackageCreateMiami' }).catch(()=>{})">
                                Limpiar
                            </button>
                            <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <span v-else>Guardar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid vstack gap-5">
                <div class="row" v-if="loading == 'package'">
                    <div class="col-12">
                        <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">GVT</small>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        #
                                    </span>
                                </div>
                                <input type="text" class="form-control form-control-sm border-right-0" v-model="number"
                                    :class="errors.id ? 'is-invalid' : ''" :readonly="search">
                                <div class="input-group-append">
                                    <span class="input-group-text" :class="search ? '' : 'bg-white'">
                                        <div class="spinner-border spinner-border-sm" role="status" v-if="key_up > 0">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.id"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-12"></div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Tracking</small>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        #
                                    </span>
                                </div>
                                <input type="text" class="form-control form-control-sm border-right-0" v-model="tracking"
                                    :class="errors.tracking ? 'is-invalid' : ''" :readonly="search">
                                <div class="input-group-append">
                                    <span class="input-group-text" :class="search ? '' : 'bg-white'">
                                        <div class="spinner-border spinner-border-sm" role="status" v-if="key_down > 0">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.tracking"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Transportista</small>
                            <v-select v-model="data.carrier_id" :items="carriers" item-text="name" item-value="id"
                                hide-details no-data class="form-control form-control-sm"
                                :class="errors.carrier_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.carrier_id"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group mb-2">
                            <small class="input-title">Descripción</small>
                            <v-combobox
                                v-model="data.description"
                                chips
                                hide-details
                                multiple
                                append-icon=""
                                clearable
                                :delimiters="[',']"
                                @click:append=""
                                class="form-control form-control-sm textarea"
                                :class="errors.description ? 'is-invalid' : ''">
                                    <template v-slot:selection="{ attrs, item, select, selected }">
                                        <v-chip
                                            small
                                            v-bind="attrs"
                                            close
                                            @click:close="REMOVE(item)"
                                            :input-value="selected">
                                            <div class="nowrap">{{ item }}</div>
                                        </v-chip>
                                    </template>
                            </v-combobox>
                            <small class="invalid-feedback" v-for="(error, index) in errors.description"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Cliente</small>
                            <search-user v-model="data.user" @set_value="e => data.user_id = e" :childclass="errors.user_id ? 'is-invalid' : ''"/>
                            <small class="invalid-feedback" v-for="(error, index) in errors.user_id" :key="index">{{
                                error
                            }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Remitente (tienda)</small>
                            <search-shipper v-model="data.shipper" :childclass="errors.shipper ? 'is-invalid' : ''"/>
                            <small class="invalid-feedback" v-for="(error, index) in errors.shipper"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Largo</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE"
                                    v-model="data.lengthy" :class="errors.lengthy ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        in
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.lengthy"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Ancho</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.width"
                                    :class="errors.width ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        in
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.width"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group mb-2">
                            <small class="input-title">Alto</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.tall"
                                    :class="errors.tall ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        in
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.tall"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mb-2">
                            <small class="input-title">Peso Volumétrico</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE"
                                    v-model="data.volumetric_weight"
                                    :class="errors.volumetric_weight ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        lbs
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.volumetric_weight"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mb-2">
                            <small class="input-title">Peso</small>
                            <div class="input-group input-group-sm">
                                <input type="text" class="form-control form-control-sm" @keypress="DOUBLE" v-model="data.weight"
                                    :class="errors.weight ? 'is-invalid' : ''">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-white">
                                        lbs
                                    </span>
                                </div>
                                <small class="invalid-feedback" v-for="(error, index) in errors.weight"
                                    :key="index">{{ error }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Piezas</small>
                            <input type="text" class="form-control form-control-sm" @keypress="NUMBER" v-model="data.pieces"
                                :class="errors.pieces ? 'is-invalid' : ''">
                            <small class="invalid-feedback" v-for="(error, index) in errors.pieces" :key="index">{{
                                error
                            }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Embalaje</small>
                            <v-select v-model="data.packing_id" :items="packings" item-text="name" item-value="id"
                                hide-details class="form-control form-control-sm"
                                :class="errors.packing_id ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.packing_id"
                                :key="index">{{ error }}</small>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Acción Requerida</small>
                            <v-select v-model="data.action" :items="actions" hide-details
                                class="form-control form-control-sm" :class="errors.action ? 'is-invalid' : ''">
                            </v-select>
                            <small class="invalid-feedback" v-for="(error, index) in errors.action" :key="index">{{
                                error
                            }}</small>
                        </div>
                        <div class="w-100" v-if="search">
                            <div class="form-group mb-2 d-flex align-items-center">
                                <small class="input-title" style="width: 140px;">Archivos Adjuntos: </small>
                                <div class="ml-2" style="width: calc(100% - 140px);">
                                    <div class="py-3"></div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2 col-6 mb-2" v-for="(item, index) in data.files">
                                    <a :href="`${item.path}`" target="_blank" rel="noopener noreferrer">
                                        <img :src="`${item.path}`" class="img-fluid" v-if="item.type != 'pdf'">
                                        <img :src="pdf" class="img-fluid" v-else>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-2">
                            <small class="input-title">Fotografias del Paquete</small>
                            <button class="form-control form-control-sm cursor-pointer mb-3" @click="oncapture = true">Escoge una imagen</button>
                            <div class="row">
                                <div class="col-md-3 col-6 mb-2" v-for="(item, index) in data.file">
                                    <a :href="`${item.path}`" target="_blank" rel="noopener noreferrer">
                                        <img :src="`${item.path}`" class="img-fluid" v-if="item.type != 'pdf'">
                                        <img :src="pdf" class="img-fluid" v-else>
                                    </a>
                                    <button type="button" @click="REMOVE_FILE(index)"
                                        class="btn position-absolute cursor-point btn-danger rounded-circle" style="width: 20px !important;height: 20px !important;right: 7px;top: -7px;font-size: 10px;padding: 5px;display: flex;">
                                        <i class="fa-solid fa-close"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalDetail from './modals/Detail'
import ModalCapture from './modals/Capture'
import { mapGetters } from 'vuex'
import pdf from '@/assets/img/pdf.png'
export default {
    components: { ModalDetail, ModalCapture },
    data() {
        let random = Math.floor((Math.random() * 99999999) + 10000000)
        return {
            data: {
                packing_id: 1,
                description: [],
                carrier_id: 1,
                lengthy: 1,
                width: 1,
                tall: 1,
                volumetric_weight: 1,
                shipper: 'Amazon',
                weight: 1,
                pieces: 1,
                action: 0,
                file: []
            },
            errors: {},
            actions: [
                { value: 0, text: 'No' },
                { value: 1, text: 'Si' }
            ],
            carriers: [],
            packings: [],
            loading: '',
            count: 0,
            number: '',
            tracking: '',
            search: false,
            key_up: 0,
            key_down: 0,
            ondetail: false,
            oncapture: false,
            id: this.$route.params.id,
            pdf
        }
    },
    computed: {
        ...mapGetters([
            'package',
        ]),
    },
    created() {
        let vue = this
        if(vue.id){
            vue.loading == 'package'
        }
        vue.INIT()
        vue.CARRIERS()
        vue.PACKINGS()
    },
    methods: {
        INIT: function () {
            let vue = this
            if(vue.id){
                vue.loading = 'package'
                if(vue.package){
                    vue.loading = ''
                    vue.number = vue.package.id
                    vue.tracking = vue.package.tracking
                    vue.data = vue.package
                    vue.ondetail = false
                    vue.search = true
                }else{
                    axios({ url: '/packages/' + vue.id, method: 'GET' })
                    .then((resp) => {
                        vue.number = resp.data.id
                        vue.tracking = resp.data.tracking
                        vue.data = resp.data
                        vue.ondetail = false
                        vue.search = true
                    })
                    .catch((err) => {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'PackageCreateMiami' })
                    })
                    .finally((resp) => {
                        vue.loading = ''
                    })
                }
                if(vue.data.state_id == 1){
                    vue.data.packing_id = 1
                    vue.data.lengthy = 1
                    vue.data.width = 1
                    vue.data.tall = 1
                    vue.data.volumetric_weight = 1
                    vue.data.weight = 1
                    vue.data.pieces = 1
                }
            }
        },
        CLEAR: function(){
            let vue = this
            vue.number = ''
            vue.tracking = ''
            vue.data = {
                packing_id: 1,
                packing_id: 1,
                description: [],
                carrier_id: 1,
                lengthy: 1,
                width: 1,
                tall: 1,
                volumetric_weight: 1,
                shipper: 'Amazon',
                weight: 1,
                pieces: 1,
                action: 0,
            }
            vue.ondetail = false 
            vue.oncapture = false 
            vue.search = false 
        },
        SEARCH: function(){
            let vue = this
            if(!vue.id){
                axios({ url: '/search/packages?number=' + vue.number + '&tracking=' + vue.tracking, method: 'GET' })
                    .then((resp) => {
                        if(resp.data.state_id >= 1 && resp.data.state_id <= 2){
                            vue.loading == 'package'
                            vue.ondetail = false
                            vue.search = true
                            vue.$store.dispatch('PACKAGE', resp.data)
                            vue.$router.replace({ name: 'PackageCreateMiami', params: { id: resp.data.id }}).catch(()=>{})
                        }else{
                            vue.$store.dispatch('PACKAGE', resp.data)
                            vue.ondetail = true
                            vue.search = false
                        }
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
            }
        },
        CREATE: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                vue.errors = {}
                let form = new FormData()
                $.each(vue.data, function(key, item) {
                    if(item != null){
                        if(key == 'description'){
                            form.append(key, JSON.stringify(item))
                        }else if(key == 'file'){
                            $.each(item, function(i, file) {
                                form.append('file[' + i + ']', file)
                            })
                        }else{
                            form.append(key, item)
                        }
                    }
                })
                if(vue.tracking){
                    form.append('tracking', vue.tracking)
                }
                axios({ url: '/miami/packages', method: 'POST', data: form })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.CLEAR()
                        resp.data.data.isTag = true
                        vue.$store.dispatch('ADD_TAGS', resp.data.data)
                        vue.$router.push({ name: 'PackageCreateMiami' }).catch(()=>{})
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                            vue.$router.push({ name: 'PackageCreateMiami' }).catch(()=>{})
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        },
        CARRIERS: function () {
            let vue = this
                axios({ url: '/all/carriers', method: 'GET' })
            .then((resp) => {
                    vue.carriers = resp.data
                })
        },
        PACKINGS: function () {
            axios({ url: '/all/packings', method: 'GET' })
                .then((resp) => {
                    this.packings = resp.data
                })
        },
        REMOVE: function(item) {
            if(this.data.description){
                this.data.description.splice(this.data.description.indexOf(item), 1)
            }
        },
        REMOVE_FILE: function (index) {
            if (this.data.file) {
                this.data.file.splice(index, 1)
            }
        },
        SAVE: function(images){
            if(!this.data.file){
                this.data.file = []
            }
            this.data.file.push(...images)
            this.oncapture = false
        }
    },
    watch: {
        number: {
            handler(value){
                let vue = this
                if(!value){
                    vue.key_up = 0
                    return
                }
                vue.key_up = value.length
                setTimeout(() => {
                    if(vue.key_up == value.length){
                        vue.SEARCH()
                        vue.key_up = 0
                    }
                }, 1000)
            }
        },
        tracking: {
            handler(value){
                let vue = this
                if(!value){
                    vue.key_down = 0
                    return
                }
                vue.key_down = value.length
                setTimeout(() => {
                    if(vue.key_down == value.length){
                        vue.SEARCH()
                        vue.key_down = 0
                    }
                }, 1000)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/CreateMiami.vue